import React from 'react';

import { Link } from 'react-router-dom';

import image from 'Demora/image';

import ReduxConnect from 'Demora/redux-connect';

import classnames from 'classnames';

import './news.scss';

import http from 'Demora/http';

import fix_news from './fix_news';

class Newsfeed extends React.Component {
	constructor(props) {
		super();

		this.state = {
			adding_news: false,
			new_news: '',
			news: {},
		};
	}

	static getDerivedStateFromProps(props, state) {
		if (props.news != state.news) {
			return { news: fix_news(props.news) };
		}

		return null;
	}

	componentWillUnmount() {
		this.unmounted = true;
	}

	fix_news_setState(w) {
		w = fix_news(w);

		this.setState({
			news: w,
		});
	}

	add_news = (e) => {
		if (this.state.adding_news) {
			return;
		}

		this.setState({
			adding_news: true,
		});

		let w = this.state.news;

		http
			.post('/data/news/' + w.$id, { m: this.state.new_news })
			.then((data) => {
				if (!data.rufP || this.unmounted || !data.names) {
					return;
				}
				this.state.news.names.u[this.props.user.id] =
					data.names.u[this.props.user.id];

				this.state.news.news.unshift(data.news);

				this.fix_news_setState(this.state.news);

				this.setState({
					adding_news: false,
					new_news: '',
				});
			});

		e.preventDefault();
	};

	add_news_keyup = (e) => {
		if (e.keyCode == 13) {
			this.add_news(e);
		}

		e.preventDefault();
	};

	action(a, i, f, s, e) {
		let user_id = this.props.user.id;

		let w = this.state.news;

		let ci = i.split('-');

		let it = 0;

		for (var ii = 0; ii < w.news.length; ii++) {
			if (w.news[ii].id == i) {
				it = ii;
			}
		}

		let itt = 0;

		if (ci[4]) {
			for (var ii = 0; ii < w.news[it].c.length; ii++) {
				if (w.news[it].c[ii].id == i) {
					itt = ii;
				}
			}
		}

		switch (a) {
			case 'feel':
				this.chfeel(s, f, i, it);

				http.put('/data/news/' + i, { action: a, f: f, s: !s }).then((data) => {
					if (!data.k) {
						this.chfeel(!s, f, i, it);
					}
				});

				break;

			case 'delete':
				if (ci[4]) {
					if (w.news[it].c[itt].cl1 === 'deleting') {
						return;
					}
					w.news[it].c[itt].cl1 = 'deleting';
				} else {
					if (w.news[it].cl1 === 'deleting') {
						return;
					}
					w.news[it].cl1 = 'deleting';
				}

				http.delete('/data/news/' + i, { action: a }).then((data) => {
					if (data.k) {
						if (ci[4]) {
							w.news[it].c[itt].cl = 'delete_elem';
						} else {
							w.news[it].cl = 'delete_elem';
						}

						if (ci[4]) {
							w.news[it].c.splice(itt, 1);
						} else {
							w.news.splice(it, 1);
						}

						this.fix_news_setState(w);
					}
				});

				break;
		}

		if (!e && f) {
			e = f;
		}

		if (e) {
			e.preventDefault();
		}
	}

	chfeel(s, f, i, it) {
		let ci = i.split('-');

		let w = this.state.news;

		let user_id = this.props.user.id;

		if (!s) {
			for (var cf in w.feels) {
				this.chfeel(true, cf, i, it);
			}
		}

		if (ci[4]) {
			if (!s) {
				w.news[it].c[itt][f].push(user_id);
			} else {
				if (w.news[it].c[itt][f].indexOf(user_id) > -1) {
					w.news[it].c[itt][f].splice(w.news[it].c[itt][f].indexOf(user_id), 1);
				}
			}
		} else {
			if (!s) {
				w.news[it][f].push(user_id);
			} else {
				if (w.news[it][f].indexOf(user_id) > -1) {
					w.news[it][f].splice(w.news[it][f].indexOf(user_id), 1);
				}
			}
		}

		this.fix_news_setState(w);
	}

	drawNews(nn, t) {
		let w = this.state.news;

		let user_id = this.props.user.id;

		return nn.map((n, i) => {
			return (
				<div key={i} className='newsitem'>
					<div className='newscont'>
						{n.u == user_id && (
							<a
								className='delete'
								href='#'
								onClick={this.action.bind(this, 'delete', n.id)}
							>
								Delete
							</a>
						)}
						<div className='media nic'>
							{this.gotoProfile(
								n.u,
								<img
									className={classnames(t + 'uim', 'mr-3 rounded')}
									src={image(w.names.u[n.u].i, 50)}
								/>,
								'float_left'
							)}
							<div
								className={classnames(
									'media-body',
									'well',
									'well-' + (t == 'n') ? 'sm' : 'xs',
									'well-no-color',
									t == 'n' ? 'newspost' : 'commentspost'
								)}
							>
								<div>
									{this.gotoProfile(
										n.u,
										w.names.u[n.u].f + ' ' + w.names.u[n.u].l,
										w.namese
									)}
								</div>
								<div className='m'>{n.m.m}</div>
								<div className='time'>{n.t}</div>
								{user_id && (
									<div className='feels'>
										{Object.keys(w.feels).map((k, v) => {
											v = w.feels[k];

											return (
												<a
													key={k}
													href='#'
													onClick={this.action.bind(
														this,
														'feel',
														n.id,
														k,
														n[k].indexOf(user_id) > -1
													)}
													className={classnames(v.c)}
													style={
														n[k].indexOf(user_id) < 0
															? {}
															: { fontWeight: 'bold', color: '#AC0101' }
													}
												>
													{v.p[3]}&nbsp;
												</a>
											);
										})}
									</div>
								)}
								<div className='who_feels'>
									{Object.keys(w.feels).map((k, f) => {
										f = w.feels[k];

										const us = n[k];

										if (us.length == 0) {
											return null;
										}

										const p = us.indexOf(user_id) != 0 ? us[0] : us[1];

										const doYou = us.indexOf(user_id) >= 0;

										return (
											<div key={k}>
												{us.indexOf(user_id) > -1 && (
													<span>
														{this.gotoProfile(user_id, 'You', '')}{' '}
														{us.length > 2
															? ', '
															: us.length > 1
																? ' and '
																: ''}
													</span>
												)}
												{((!doYou && us.length > 0) ||
													(doYou && us.length > 1)) && (
													<span>
														{this.gotoProfile(
															p,
															w.names.u[p].f + ' ' + w.names.u[p].l,
															''
														)}
													</span>
												)}
												{((!doYou && us.length > 1) ||
													(doYou && us.length > 2)) && (
													<span>
														{((!doYou && us.length > 0) ||
															(doYou && us.length > 1)) &&
														!!w.names.u[p].f
															? ' and ' +
																(us.length -
																	(us.indexOf(user_id) >= 0 ? 1 : 0) -
																	1) +
																' other' +
																(us.length - (doYou ? 1 : 0) - 1 > 1 ? 's' : '')
															: us.length - (doYou ? 1 : 0) - 1 + ' people '}
													</span>
												)}{' '}
												{f.p[us.length > 1 ? 1 : 2]} this
											</div>
										);
									})}
								</div>
							</div>
						</div>
					</div>
				</div>
			);
		});
	}

	gotoProfile(u, t, c) {
		return (
			<Link
				to={'/website_traffic/home/user_profile.php?uid=' + u}
				className={c}
			>
				{t}
			</Link>
		);
	}

	handleChange = (event) => {
		this.setState({ new_news: event.target.value });
	};

	render() {
		let w = this.state.news;

		let userProfile = this.props.userProfile;

		return (
			<div>
				{w.can_post && (
					<div>
						<div>
							<div className='input-group'>
								<input
									disabled={this.state.adding_news}
									value={this.state.new_news}
									onChange={this.handleChange}
									type='text'
									className='form-control'
									onKeyUp={this.add_news_keyup}
									placeholder='Write something here......'
								/>
								<span className='input-group-btn'>
									<button
										className='btn btn-primary'
										type='button'
										onClick={this.add_news}
									>
										{!this.state.adding_news && <span>Post</span>}
										{this.state.adding_news && (
											<img
												className='post-saving'
												src='/images/ajax-loader.gif'
											/>
										)}
									</button>
								</span>
							</div>
						</div>
					</div>
				)}

				<br />
				<br />

				{w.news.length == 0 && (
					<div className='text-center'>
						<br />
						<b>
							{userProfile.user.first_name} hasn't written anything on their
							profile.
						</b>
					</div>
				)}

				<div className='newsfeed'>
					{w.news.length > 0 && this.drawNews(w.news, 'n')}
				</div>
			</div>
		);
	}
}

export default ReduxConnect(Newsfeed, {
	user: 'user',
});
